/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Weight {
    Kilogram = 'Kilogram',
    Pound = 'Pound'
}

export function WeightFromJSON(json: any): Weight {
    return WeightFromJSONTyped(json, false);
}

export function WeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): Weight {
    return json as Weight;
}

export function WeightToJSON(value?: Weight | null): any {
    return value as any;
}

